module.exports = __webpack_public_path__ + "static/img/YS-head.79ce069.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/YS-head.jpg
// module id = 270t
// module chunks = 1